import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AlertsContext from "common/providers/alerts";
import UserForm from "./UserForm";

function User() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;
  const role_name = router.query.role as string;

  const {
    saveItem,
    updateItem,
    item: otherUser,
    error,
    isFetching,
  }: any = useItem('users', id, {
    populate: ['role', 'profiles', 'operator'],
  });

  useEffect(() => {
    if (error) {
      setAlert(
        error === 'This attribute must be unique'
          ? t('common.emailAlreadyTaken')
          : t('common.error'),
        'danger'
      );
    }
  }, [error, setAlert, t]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t('common.saved'), 'success');
      router.navigate('/users');
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (userData: any) => {
      const user = { ...userData };

      try {
        if (user.id) {
          // update user then go back
          await updateItem(user.id, user, false);

          back();
        } else {
          // create new user, then go to it's profile creation form,
          // sending the newly created user id for association.
          const newUser = await saveItem(user, false);
          user.id = newUser.id;

          if (
            user.role_name === 'Mediator' ||
            user.role_name === 'Administrateur' ||
            user.role_name === 'SuperAdmin'
          ) {
            router.navigate(`/mediators/add?userId=${user.id}`);
          } else {
            router.navigate(`/students/add?userId=${user.id}`);
          }
        }
      } catch (e: any) {
        return e;
      }

      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !otherUser) ? null : (
    <UserForm
      onSubmit={onSubmit}
      editedUser={{ ...otherUser, ...(role_name ? { role_name: role_name } : {}) }}
    />
  );
}

export default User;
